import ChapterDisplay from './ChapterDisplay';
import Comments from './Comments';

export default function Capitulo11() {
    const section = 'las-batallas';
    const title = 'Las batallas';
    const description = 'Después de caer al vacío, ¡mi cuerpo se empezó a disolver!';
    const text = '<p>Estaba a nada de desaparecer cuando la voz de Don Juan me recordó que yo no soy solo mi cuerpo, ¡soy Valentina! Y justo cuando me acordé de mi familia y de Taquito, él se aventó a rescatarme. ¡No sabes qué héroe! Se volvió una especie de ajolote gigante que voló entre relámpagos para salvarme y me dio un beso. ¡Ahora soy azul y puedo sentir todo!</p><p>Regresé a mi cuerpo, pero ahora estábamos en otro lugar. ¡Y Camazotz nos encontró! Mi amigo Taquito, con sus nuevos poderes de rayo, se hizo enorme para pelear contra él y salvarme, pero el monstruo lo hirió de muerte. Taquito se sacrificó para que yo pudiera vivir y, llena de tristeza y furia, ¡lo derroté! Gracias a Choc que se convirtió en  mi armadura de piedra, le dimos unos buenos golpes, ¡hasta que se hizo chiquito!</p><p>Cuando lo tenía acorralado, no sabía qué hacer para volver a casa. De repente, una voz se comunicó conmigo a través de mis recuerdos. ¡Era Don Juan! Él me dijo que la única forma de volver es encerrar a Camazotz. Ahora sé lo que tengo que hacer para que el sacrificio de Taquito no sea en vano.</p>';
    const image = '';
    const image_number = 'https://www.diadelavida.com/images/numbers/11.png'
    const image_size = 'contain';
    const image_position = 'center';
    const image_height = 0;
    const comments_prompt = 'Estamos tristes por Taquito, ¿qué harías tú en el lugar de Valentina?';

    const images = [
        {
            id: 1,
            src: 'https://www.diadelavida.com/images/chapters/capitulo11_main.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 11',
            description: 'Inicia la batalla contra Camazotz...'
        },
        {
            id: 2,
            src: 'https://diadelavida.com/images/cards/card_valentina_03.jpg',
            alt: 'Noche de Muertos | Día de la Vida - Capítulo 11',
            description: 'La armadura más fuerte, ¡Choc me protege!'
        },
    ];

    return (
        <div>
            <ChapterDisplay
                section={section}
                title={title}
                description={description}
                text={text}
                image={image}
                imageSize={image_size}
                imagePosition={image_position}
                imageHeight={image_height}
                images={images}
                imageNumber={image_number}
            />
            <div id='users-comments'>
                <div className="comments-deco"></div>
                <div className="container">
                    <div className="row">
                        <Comments sectionId={section} commentsPrompt={comments_prompt} />
                    </div>
                </div>
            </div>
        </div>
    );
}